module.exports = __webpack_public_path__ + "static/media/facebook-icon.3405025c.svg";